import { makeStyles, createStyles } from "@material-ui/core";


export default makeStyles(() =>
    createStyles({
        dragVertical: {
            width: 24,
            height: 24,
        },
        lvtLogoBlack: {
            "& path": {
                fillRule: "evenodd",
            },
        },
        shieldIcon: {
            enableBackground: "new 0 0 24 24",
            marginLeft: -1,
        },
        luadminIcon: {
            enableBackground: "new 0 0 24 24",
            marginLeft: 1,
        },
        imageNotFound: {
            margin: "auto",
        },
    }),
);
